import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BankTransferData } from '../../../../models/acquista-servizi-models/bankTransferData';
import { OrdersStore } from './orders.store';
import { PurchaseData } from '../../../../models/acquista-servizi-models/purchaseData';
import { ConstantsStore } from '../../constants.store';
import {
  Cart,
  GenericProduct,
} from '../../../../models/acquista-servizi-models/cart';
import { CartItem } from '../../../../models/acquista-servizi-models/cartItem';
import { Helpers } from 'src/app/models/Helpers/helpers';
import { Order, OrderDataForUpdating } from 'src/app/models/acquista-servizi-models/order';
import { Router, UrlSerializer } from '@angular/router';
import { OrdersFilters } from 'src/app/models/acquista-servizi-models/ordersFilters';
import { OrdersData } from 'src/app/models/acquista-servizi-models/ordersData';
import { CACHE_KEY } from '../../interceptors/cache-header.interceptor';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(
    private store: OrdersStore,
    private constants: ConstantsStore,
    private http: HttpClient,
    private router: Router,
    private serializer: UrlSerializer
  ) { }


  getOrders(numberPage: number, filters: OrdersFilters): Observable<any> {
    return new Observable(observer => {
      this._apiGet(numberPage, filters)
        .subscribe(
          ordersData => {
            this.store.loadOrders(ordersData.orders, ordersData.totalOrders);
            this.store.loadAutocompleteValues(ordersData.usernames);
            observer.next();
          },
          error => {
            observer.error(error);
          }
        );
    });
  }

  postNewOrder(purchaseData: PurchaseData): Observable<BankTransferData | any> {
    return new Observable((observer) => {
      this._apiPost(purchaseData).subscribe(
        (bankTransferData) => {
          observer.next(bankTransferData);
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
  sendMails(orderData: any): Observable<any> {
    return new Observable((observer) => {
      this.http.post(this.constants.orderSendMailsUrl, orderData)
        .subscribe(
          () => {
            observer.next();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  postHandmadeOrder(orderData: any) {
    return new Observable(observer => {
      this.http.post(`${this.constants.ordersUrl}/Manually`, orderData)
        .subscribe(
          () => observer.next(),
          error => observer.error(error)
        );
    });
  }

  updateOrder(orderData: OrderDataForUpdating) {
    return new Observable(observer => {
      this.http.patch(this.constants.ordersUrl, orderData)
        .subscribe(
          () => observer.next(),
          error => observer.error(error)
        );
    });
  }

  updateOrderStatusInStore(order: Order) {
    const requiredIndex = this.store.orders.indexOf(order);
    this.store.orders[requiredIndex].activatedByHand = 1;
    this.store.orders[requiredIndex].isPaid = 1;
    this.store.orders[requiredIndex].paymentDate = new Date();
  }

  private _apiGet(numberPage: number, filters: OrdersFilters): Observable<OrdersData> {

    const tree = this.router.createUrlTree([''], { queryParams: filters });
    const serializedFilters = this.serializer.serialize(tree);

    return this.http.get<OrdersData>(`${this.constants.ordersUrl}/${numberPage}/${this.store.pageSize}${serializedFilters}`, {
      headers: {
        [CACHE_KEY]: '1'
      }
    });
  }
  private _apiPost(purchaseData: PurchaseData): Observable<BankTransferData> {
    return this.http.post<BankTransferData>(
      this.constants.ordersUrl,
      purchaseData
    );
  }



  addItemToCart(productToAdd: GenericProduct) {
    if (
      this.store.cart.items.length > 0 === false ||
      this._isANewProduct(productToAdd) === true
    ) {
      const newCartItem: CartItem = {
        amount: 1,
        productId: productToAdd.id,
        productName: productToAdd.name,
        productPriceCadauno: Helpers.roundPrecision(productToAdd.price, 2),
        productIvaCadauno: Helpers.roundPrecision(
          productToAdd.price * productToAdd.iva, 2
        ),
        totalPrice: Helpers.roundPrecision(
          productToAdd.price + productToAdd.price * productToAdd.iva,
          2
        ),
      };
      this.store.cart.items.push(newCartItem);
    } else {
      const cartItemIndex = this._findCartItemIndexByProductId(productToAdd.id);
      this._updateCartItemData(true, cartItemIndex, productToAdd);
    }

    this.store.atLeastOneItemInCartExists = true;
    this.store.cart.totalPrice = this._setCartTotalPrice();
  }
  private _isANewProduct(productToCheck: GenericProduct): boolean {
    const arrayId = [];
    this.store.cart.items.forEach((item) => {
      arrayId.push(item.productId);
    });
    const productIdExists = arrayId.indexOf(productToCheck.id);

    if (productIdExists === -1) {
      return true;
    }
    return false;
  }
  private _findCartItemIndexByProductId(productId: number): number {
    const requiredIndex = this.store.cart.items
      .findIndex((cartItem: CartItem) => cartItem.productId === productId);

    return requiredIndex;
  }
  private _updateCartItemData(
    wantToAdd: boolean,
    cartItemIndex: number,
    product: GenericProduct
  ): void {
    if (wantToAdd === true) {
      this.store.cart.items[cartItemIndex].amount += 1;
    } else {
      this.store.cart.items[cartItemIndex].amount -= 1;
    }
    const productAmount = this.store.cart.items[cartItemIndex].amount;

    this.store.cart.items[cartItemIndex].totalPrice = Helpers.roundPrecision(
      (product.price + product.price * product.iva) * productAmount, 2
    );
  }

  deleteItemFromCart(cartItem: CartItem) {
    const itemIndex = this.store.cart.items.indexOf(cartItem);
    this.store.cart.items.splice(itemIndex, 1);

    this.store.cart.totalPrice = this._setCartTotalPrice();
    if (this.store.cart.items.length > 0 === false) {
      this.store.atLeastOneItemInCartExists = false;
    }
  }

  private _setCartTotalPrice(): number {
    let totalPrice = 0;
    this.store.cart.items.forEach((item) => {
      totalPrice += item.totalPrice;
    });
    return Helpers.roundPrecision(totalPrice, 2);
  }


  getPaymentMethodName(acronym: string): string {
    if (acronym === 'B') {
      return 'Bonifico Bancario';
    }
  }
  getCartHTML(cart: Cart): string {
    let cartHtml = '';
    cart.items.forEach((item) => {
      cartHtml += `<tr>
            <td bgcolor='#ffffff'>${item.productName}</td>
            <td bgcolor='#ffffff' style='text-align: center'>${item.amount}</td>
            <td bgcolor='#ffffff' style='text-align: center'>${Helpers.toLocalCurrency(
        Helpers.roundPrecision(item.totalPrice, 2)
      )}</td>
         </tr>`;
    });
    return cartHtml;
  }

  findOrderDetails(orderId: string): Order {
    return this.store.orders.filter(order => order.orderId.toString() === orderId)[0];
  }
  updatePageNumber(newPageNumber: number) {
    this.store.pageNumber = newPageNumber;
  }
  updateFiltersInStore(filters: OrdersFilters) {
    this.store.filters = filters;
  }
}
